// Jediný zdroj českých názvů rolí (stejné jako backend config.ROLE_LABELS).
export const ROLE_LABELS = {
  OWNER: "Majitel", MANAGER: "Stavbyvedoucí", WORKER: "Dělník", SUBCONTRACTOR: "Subdodavatel",
  ASSISTANT: "Asistent/ka", ACCOUNTANT: "Účetní", WAREHOUSE: "Skladník", DESIGNER: "Projektant",
};
export const roleLabel = (r) => ROLE_LABELS[r] || "Dělník";
